import gql from 'graphql-tag'

export const getPublicSyncedPreOffer = gql`
  query DooerComGetPublicSyncedPreOffer($shortid: String!) {
    publicAccountingOnboardingSyncedPreOffer(shortid: $shortid) {
      id
      organizationId
      token
      idNumber
      bankInstitution
    }
  }
`
